import "@services/crashReporting/sentry"
import "./polyfills"
import React from "react"
import ReactDOM from "react-dom"
import AppLayout from "./views/layouts/AppLayout"
import * as serviceWorker from "./serviceWorker"
import "./i18n"

ReactDOM.render(
	<React.StrictMode>
		<AppLayout />
	</React.StrictMode>,
	document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
